import React, { useState, useEffect } from "react";
import { Trans } from "react-i18next";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import Divider from "@material-ui/core/Divider";
import Chip from "@material-ui/core/Chip";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import UserAutosuggest from "./../UserAutosuggest";
import TeamAutosuggest from "./../TeamAutosuggest";
import { taxServiceClient } from "../../AxiosClient";

function UserTeamPicker(props) {
  const [users, setUsers] = useState(props.loadUsers || []);
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState({});
  const [teamFilter, setTeamFilter] = useState({});
  const [teamUsers, setTeamUsers] = useState([]);

  useEffect(
    () => {
      // if (props.loadUsers && props.loadUsers !== null) {
        setUsers(props.loadUsers);
      // }
    },
    [props.loadUsers]
  );
  useEffect(
    () => {
      users && props.onUsersUpdate && props.onUsersUpdate(users);
    },
    [users]
  );

  useEffect(
    () => {
      teamUsers &&
        !props.usersOnly &&
        props.onTeamUsersUpdate &&
        props.onTeamUsersUpdate(teamUsers);
    },
    [teamUsers]
  );

  const removeTeam = (team) => {
    setTeams(teams.filter((ele) => ele.teamName !== team.teamName));
  };

  const addTeam = (team) => {
    props.loadingUsers && props.loadingUsers(true);
    setTeams([...teams, team]);
    taxServiceClient.get(`/team/${team.teamId}/userIds`).then((res) => {
      setTeamUsers([...teamUsers, ...res.data.map((ele) => ele)]);
      props.loadingUsers && props.loadingUsers(false);
    });
    if (props.onTeamSelected) {
      props.onTeamSelected(team);
    }
  };

  const handleTeamFilterChange = (event) => {
    setTeamFilter(event.target.value);
  };

  const handleTeamChange = (e) => {
    setSelectedTeam(e.target.value);
  };

  const removeUser = (user) => {
    setUsers(users.filter((ele) => ele.userId !== user.userId));
  };

  const onUserSelected = (user) => {
    //clearing the input calls this with a null value
    if (user !== null && user.hasOwnProperty("userId")) {
      if (!users || !users.some((u) => u.userId === user.userId)) {
        setUsers(!users ? [user] : [...users, user]);
      }
    }
  };

  return (
    <>
      <div style={{ marginBottom: 10 }}>
        {props.asChips && (
          <FormControl>
            <div>
              {users &&
                users.length === 0 &&
                teams.length === 0 &&
                !props.hideNoUsersMessage && (
                  <Typography
                    color="textSecondary"
                    style={{ marginBottom: 10 }}
                  >
                    <Trans i18nKey="required_reading_no_users_selected" />
                  </Typography>
                )}
              {users &&
                users.map((user) => (
                  <Chip
                    style={{ margin: 2 }}
                    onDelete={() => removeUser(user)}
                    label={`${user.firstName} ${user.surname} (${
                      user.userLogin
                    })`}
                  />
                ))}
              {!props.usersOnly &&
                teams &&
                teams.map((team) => (
                  <Chip
                    style={{ margin: 2 }}
                    onDelete={() => removeTeam(team)}
                    label={team.teamName + " (team)"}
                  />
                ))}
            </div>
          </FormControl>
        )}
        {props.userHeaderKey && (
          <Typography style={{ marginBottom: 10 }}>
            <Trans i18nKey={props.userHeaderKey} />
          </Typography>
        )}
        <UserAutosuggest onItemSelected={onUserSelected} clearOnSelect />
        {!props.usersOnly && (
          <div>
            {props.userTeamHeaderKey && (
              <Typography style={{ marginBottom: 10 }}>
                <Trans i18nKey={props.userTeamHeaderKey} />
              </Typography>
            )}
            <TeamAutosuggest onItemSelected={addTeam} clearOnSelect />
          </div>
        )}
        {!props.asChips && (
          <Paper>
            {(!users || (users.length === 0 && teams.length === 0)) && (
              <Typography style={{ textAlign: "center", marginTop: 15 }}>
                <Trans i18nKey="required_reading_no_users_selected" />
              </Typography>
            )}
            <List>
              {users &&
                users.map((ele) => {
                  return (
                    <>
                      <ListItem>
                        <ListItemText
                          primary={`${ele.firstName} ${ele.surname}`}
                          secondary={ele.userLogin}
                        />
                        <ListItemSecondaryAction>
                          <IconButton onClick={() => removeUser(ele)}>
                            <ClearIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Divider component="li" />
                    </>
                  );
                })}
              {teams &&
                teams.map((ele) => {
                  return (
                    <>
                      <ListItem>
                        <ListItemText primary={ele.teamName} secondary="Team" />
                        <ListItemSecondaryAction>
                          <IconButton onClick={() => removeTeam(ele)}>
                            <ClearIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Divider component="li" />
                    </>
                  );
                })}
            </List>
          </Paper>
        )}
      </div>
    </>
  );
}

export default UserTeamPicker;
